import {SET_CATEGORIES} from '../constanst/index';

export function setCategories(categories) {
    return async(dispatch) => {
        try {
            dispatch({
                type: SET_CATEGORIES,
                payload: categories,
            });

        } catch (error) {
            console.log(error);
        }

    }
}